import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { WaterUsage } from './models/WaterUsage';

import { WATER_USAGE } from './mock-data/mock-data';

export interface BillingHistoryData {
  date: Date;
  type: string;
  amount: number;
}

let billingHistoryData: BillingHistoryData[] = [
  { date: new Date('08/03/2018'), type: 'Bill', amount: 0.00 },
  { date: new Date('07/19/2018'), type: 'Payment', amount: 0.00 },
  { date: new Date('07/05/2018'), type: 'Bill', amount: 0.00 },
  { date: new Date('06/19/2018'), type: 'Payment', amount: 0.00 },
  { date: new Date('06/05/2018'), type: 'Bill', amount: 0.00 },
  { date: new Date('05/17/2018'), type: 'Payment', amount: 0.00 },
]

@Injectable()
export class PowerUsageService {

  constructor(private http: HttpClient) {}

  getWaterUsageData(): WaterUsage[] {
    return WATER_USAGE;
  }

  getBillingAndPaymentHistory(): BillingHistoryData[] {
    return billingHistoryData;
  }

  getTestData() {
    return this.http.get('/Portal/Sample');
  }

}



// WEBPACK FOOTER //
// ./src/app/power-usage.service.ts